export const DEFAULT_NEW_CONSTRUCTION_OPTIONS = [
  { name: 'Nyprod. & succession', value: null },
  { name: 'Nyproduktion', value: 1 },
  { name: 'Succession', value: 0 },
];

export const SUCCESSION_ONLY_OPTIONS = DEFAULT_NEW_CONSTRUCTION_OPTIONS.filter((option) => option.value === 0);
